import React from 'react';
import cn from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import UserLink from '../../../User/Link/UserLink';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import { formatDollars } from '../../../utils/formatting';
import { getDeviationPrice } from '../../helpers';
import s from './Details.scss';
var USER_AVATAR_SIZE = 24;
var Details = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var _b = getDeviationPrice(deviation), dollarsPrice = _b.dollarsPrice, pointsPrice = _b.pointsPrice;
    return (React.createElement("div", { className: cn(s['root'], className) },
        React.createElement("div", { className: s['avatar'] },
            React.createElement(UserAvatar, { user: deviation.author, size: USER_AVATAR_SIZE })),
        React.createElement("div", { className: s['title'] }, deviation.title),
        React.createElement("div", { className: s['price-dollars'] }, dollarsPrice && formatDollars(dollarsPrice)),
        React.createElement("div", { className: s['username'] },
            React.createElement(UserLink, { user: deviation.author })),
        React.createElement("div", { className: s['price-points'] },
            pointsPrice && (React.createElement(PointsIcon, { size: IconSize.TINY, disableDefaultColors: true })),
            pointsPrice)));
};
Details.displayName = 'Details';
export default Details;
//# sourceMappingURL=Details.js.map